import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { useWorkspaces } from '../../hooks/useWorkspace';
import { useWorkspaceStore } from '../../stores/workspaceStore';

export function AppHome() {
  const { t } = useTranslation();
  const { data: user, isLoading } = useCurrentUser();
  const { data: workspaces, isLoading: wsLoading } = useWorkspaces();
  const lastWorkspaceId = useWorkspaceStore((s) => s.lastWorkspaceId);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || wsLoading) return;
    if (!user) {
      window.location.assign('/');
      return;
    }
    if (!user.companyId) {
      // PlyEZ-staff admins don't have a company — bounce them to /admin
      // instead of demanding company onboarding.
      if (user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/onboarding');
      }
      return;
    }
    if (workspaces && workspaces.length > 0) {
      // Prefer the last workspace the user was actually inside; fall back
      // to the first one if it's unknown or no longer exists.
      const target = workspaces.find((w) => w.id === lastWorkspaceId) ?? workspaces[0];
      navigate(`/app/workspace/${target.id}/home`);
    } else {
      navigate('/onboarding');
    }
  }, [user, workspaces, lastWorkspaceId, isLoading, wsLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-ink-500">
      {t('appHome.loading')}
    </div>
  );
}
